export const resendInviteFormConstants = Object.freeze({
  HEADING: 'Send New Temporary Password',
  EXPIRED_MESSAGE_1: 'Your temporary password is expired and needs to be resent.',
  EXPIRED_MESSAGE_2: 'Click the button below to receive a new temporary password.',
  SEND_NEW_PW_BUTTON: 'Send New Temporary Password',
})

export const resendInviteCompleteConstants = Object.freeze({
  HEADING: 'Temporary Password Sent',
  COMPLETE_MESSAGE_1: 'Your new temporary password has been sent.',
  COMPLETE_MESSAGE_2: 'Please check your email and follow the instructions there.',
})
